
<template>
    <v-dialog persistent
              v-model="$store.getters.textAndPercentageDialog"
              max-width="600">


        <v-card>
            <v-card-title
                    class="headline primary white--text"
                    primary-title>
                <v-spacer></v-spacer>
                <v-icon @click="closeModal" color="white">close</v-icon>
            </v-card-title>

            <v-card-text class="mt-5">
                <v-form v-model="validForm">
                    <v-row justify="center">
                        <v-col>
                            <v-textarea :readonly="readOnlyMode"
                                    rows="2" row-height="3"
                                    counter :label="openedAsInternalComment ? 'Εσωτερικό Σχόλιο Επιτροπής' : 'Αιτιολογία Μείωσης'"
                                    :clearable="!readOnlyMode" filled auto-grow
                                    v-model="text">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="showPercentage">
                        <v-card style="min-width: 550px" >
                            <v-toolbar flat dense >
                                <v-toolbar-title>
                                    <span >{{openedAsInternalComment? 'Ποινή πρώτου ακαδημαϊκού έτους κλειδώματος' : 'Ποσοστιαία Μείωση'}}</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-checkbox :readonly="readOnlyMode" v-model="checkbox" class="pt-5 pl-2"/>
                            </v-toolbar>

                            <v-card-text v-if="checkbox" class="pt-0 pb-0 mt-0 mb-0">
                                <v-row justify="center">
                                    <v-col cols="3">
                                        <v-text-field readonly v-model="percentage"
                                                      append-icon="mdi-percent"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions style="justify-content: center">
                <v-btn style="min-width: 150px" @click="closeModal()">
                    Άκυρο
                </v-btn>

                <v-btn :disabled="!validForm ||readOnlyMode" style="min-width: 150px" color="primary" @click="sendData()">
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        name: "TextAndPercentageDialog",
        data: () => ({
            text: '',
            percentage: 0,
            checkbox: false,
            validForm: false
        }),
        props: {
            eventName: String,
            textInput: String,
            percentageInput: Number,
            showPercentage: Boolean,
            componentKey: Number,
            readOnlyMode:Boolean,
            openedAsInternalComment:Boolean,
        },

        methods: {
            closeModal(){
                this.percentage = 0;
                this.checkbox = false;
                this.text = '';
                this.$store.commit('setTextAndPercentageDialog', false);
            },

            sendData(){
                // let bla = this.percentage / 100;
                // this.$store.commit('setTextAndPercentageDialog', false);
                // eventBus.$emit(this.eventName, bla, this.text);
            },

        },
        watch: {
            'componentKey': function () {
                if(!this.openedAsInternalComment){
                    this.checkbox = true;
                }
                this.text = this.textInput;
                this.percentage = this.percentageInput;
            },
            'checkbox': function (val) {
                if(!val){ // every time checkbox = false
                    this.percentage = 0;
                }
            },
        }
    }
</script>

<style scoped>

</style>